import { preloaderActionTypes } from '../actions/preloader-action-types';
import { removeAssetFromArray, addAssetToArrayIfNew } from '../../common/reducer-helpers';

const preloaderInitialState = {
	
    assetsToPreload:[],
    assetsPreloaded:[]
};

export const preloader = (state = preloaderInitialState, action) => {
	switch (action.type) {
		
			case preloaderActionTypes.PRELOADER_ADD_FILES:
			return{...state, assetsToPreload: [...state.assetsPreloaded, ...action.assets]};

			case preloaderActionTypes.PRELOADER_CLEAR_FILES:
			return{...state, assetsToPreload: []};

			case preloaderActionTypes.PRELOADER_FILE_LOADED:
			return{...state, 
				assetsPreloaded: addAssetToArrayIfNew(state.assetsPreloaded, action.asset),
			assetsToPreload: removeAssetFromArray(state.assetsToPreload, action.asset)};


			
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/preloader/reducers/preloader-reducer.js